module.exports = __webpack_public_path__ + "img/12.631f8d53.png";